module.exports={close:"Chiudi",error:"Errore",info:"Informazioni",success:"Operazione riuscita",warning:"Avvertenza"};